import MenuItem from '../entity/MenuItem';

export const RoutePath = {
    ACCOUNT_USER_LOGIN_PASSWORD: new MenuItem("ACCOUNT_USER_ROUTE_LOGIN_PASSWORD", "/account/login"),
    ACCOUNT_USER_LIST: new MenuItem("ACCOUNT_USER_ROUTE_LIST", "/account/users"),

    ACCOUNT_USER_CENTER: new MenuItem("ACCOUNT_USER_ROUTE_CENTER", "/account/user/center", "user"),
    ACCOUNT_USER_PROFILE: new MenuItem("ACCOUNT_USER_ROUTE_PROFILE", "/account/user/profile"),
    ACCOUNT_USER_REGISTER: new MenuItem("ACCOUNT_USER_ROUTE_REGISTER", "/account/user/register"),
    ACCOUNT_USER_PASSWORD: new MenuItem("ACCOUNT_USER_ROUTE_PASSWORD", "/account/user/password"),
    ACCOUNT_USER_PASSWORD_FORGOT: new MenuItem("ACCOUNT_USER_ROUTE_PASSWORD_FORGOT", "/account/user/password/forgot"),

    // 用户组织管理
    ORG_MANAGEMENT: new MenuItem("ORG_ROUTER_MANAGEMENT", "/org/management", "team"),
    ORG_ORGANIZATION_LIST: new MenuItem("ORG_ORGANIZATION_ROUTE_LIST", "/org/organizations"),
    ORG_EMPLOYEE_LIST: new MenuItem("ORG_EMPLOYEE_ROUTE_LIST", "/org/employees"),
    ORG_EMPLOYEE_PROFILE: new MenuItem("ORG_EMPLOYEE_ROUTE_PROFILE", "/org/employee/profile"),

    WMS_ZONE_CREATE: new MenuItem("WMS_ZONE_ROUTE_CREATE", "/wms/zone/create"),
    WMS_ZONE_UPDATE: new MenuItem("WMS_ZONE_ROUTE_UPDATE", "/wms/zone/update/:id"),
    WMS_ZONE_LIST: new MenuItem("WMS_ZONE_ROUTE_LIST", "/wms/zones/list"),
    WMS_ZONE_DETAIL: new MenuItem("WMS_ZONE_ROUTE_DETAIL", "/wms/zone/detail/:id"),
    WMS_ZONE_MAP: new MenuItem("WMS_ZONE_ROUTE_MAP", "/wms/zones/map"),
    WMS_ZONE_SEARCH_FUZZY: new MenuItem("WMS_ZONE_ROUTE_SEARCH_FUZZY", "/wms/zones/searchFuzzy"),

    WMS_ZONE_POSITION: new MenuItem("WMS_ZONE_ROUTE_POSITION", "/wms/zone/position/:id"),

    WMS_ZONE_LOCATION: new MenuItem("WMS_ZONE_ROUTE_LOCATION", "/wms/zone/create/location"),

    WMS_BUILDING_CREATE: new MenuItem("WMS_BUILDING_ROUTE_CREATE", "/wms/building/create"),
    WMS_BUILDING_UPDATE: new MenuItem("WMS_BUILDING_ROUTE_UPDATE", "/wms/building/:id"),

    // 方案比较
    WMS_PROPOSAL_COMPARE: new MenuItem("WMS_PROPOSAL_ROUTE_COMPARE", "/wms/proposal/compare/:groupId"),

    WMS_PROPOSAL_COMPARE_MOBILE: new MenuItem("WMS_PROPOSAL_ROUTE_COMPARE", "/m/wms/proposal/compare/:groupId"),
    WMS_PROPOSAL_COMPARE_PC: new MenuItem("WMS_PROPOSAL_ROUTE_COMPARE", "/pc/wms/proposal/compare/:groupId"),

    WMS_PROPOSAL_DETAIL: new MenuItem("WMS_PROPOSAL_ROUTE_DETAIL", "/wms/proposal/detail/:id"),

    // 带看详情
    WMS_BUSINESS_SCHEDULER_DETAIL_VIEW: new MenuItem("WMS_BUSINESS_SCHEDULER_DETAIL_VIEW", "/wms/businessScheduler/view/:schedulerId"),
    WMS_BUSINESS_SCHEDULER_LIST_VIEW: new MenuItem("WMS_BUSINESS_SCHEDULER_LIST_VIEW", "/wms/businessScheduler/list"),

    // 任务发布
    WMS_TODO_LIST: new MenuItem("WMS_TODO_ROUTE_LIST", "/wms/todo/list"),
    WMS_TODO_DETAIL: new MenuItem("WMS_TODO_ROUTE_DETAIL", "/wms/todo/detail/:id"),

    WMS_CONTACTS_FILTER: new MenuItem("WMS_CONTACTS_ROUTE_FILTER", "/wms/contacts/filter"),
    WMS_CONTACTS_DETAIL: new MenuItem("WMS_CONTACTS_ROUTE_DETAIL", "/wms/contacts/detail"),


};